<span class="status status-{{ value | lowercase }}">{{ showText ? value : '' }}</span>